export default __webpack_public_path__ + "static/media/ih-cr-ok-aec.3f5eaa14.svg";